import FullscreenModal from './FullscreenModal';

export default FullscreenModal;
export { FullscreenModal };
